import DashboardSummaryCountsWidget from '../../../../components/DashboardSummaryCountsWidget/SummaryCountWidget'
import SvgIconFileShares from '../../../../assets/inlineSvg/icon-shares.svg'
import SvgIconPolicies from '../../../../assets/inlineSvg/icon-policies.svg'
import { RootState } from '../../../../rootReducer'
import useUrlContext from '../../../../hooks/useUrlContext'
import {
  fetchFileSharesCount,
  FileSharesCountParams
} from '../../../dashboardSummary/dashboardSummarySlice'
import { mockSmbSummaryCountsWidgetData } from '../../renderer/utils/widgetMockdata'
import { getUniqueWidgetIndex, UNIQUE_WIDGET_INDEX } from '../../mainDashboardv2/constants'
import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import React, { useEffect } from 'react'

interface OwnProps {
  useMockData?: boolean
  widgetDatasourceId?: string
  widgetDashboardId?: string
}

interface StateProps {
  fileSharesCount?: number
  policiesCount?: number
}

interface DispatchProps {
  fetchFileSharesCount: (params: FileSharesCountParams & { [UNIQUE_WIDGET_INDEX]?: string }) => void
}

type SmbSummaryCountsWidgetComponentProps = StateProps & DispatchProps & OwnProps

const SmbSummaryCountsWidget = (props: SmbSummaryCountsWidgetComponentProps) => {
  const {
    fileSharesCount,
    policiesCount,
    useMockData = false,
    widgetDatasourceId,
    widgetDashboardId,
    fetchFileSharesCount
  } = props

  const intl = useIntl()
  const context = useUrlContext()
  const datasourceId = widgetDatasourceId
    ? widgetDatasourceId
    : context.contextFilters.datasourceId || ''
  const widgetIndex = getUniqueWidgetIndex(widgetDashboardId, widgetDatasourceId)
  useEffect(() => {
    if (useMockData) return
    datasourceId && fetchFileSharesCount({ datasourceId, [UNIQUE_WIDGET_INDEX]: widgetIndex })
  }, [fetchFileSharesCount, datasourceId, useMockData, widgetIndex])

  const widgetElements = [
    {
      icon: <SvgIconFileShares />,
      text: intl.formatMessage({ id: 'dashboard.generic.widget.text.shares' }),
      count: fileSharesCount || 0
    },
    {
      icon: <SvgIconPolicies />,
      text: intl.formatMessage({ id: 'dashboard.dataSource.widget.text.policies' }),
      count: policiesCount || 0
    }
  ]

  const countsAvailable = policiesCount !== undefined && fileSharesCount !== undefined
  const showLoader = !countsAvailable

  return (
    <DashboardSummaryCountsWidget
      summaryItems={widgetElements}
      showLoader={showLoader}
      useMockData={useMockData}
    />
  )
}

const mapStateToProps = (state: RootState, ownProps: OwnProps): StateProps => {
  const widgetIndex = getUniqueWidgetIndex(ownProps.widgetDashboardId, ownProps.widgetDatasourceId)
  return {
    fileSharesCount: ownProps?.useMockData
      ? mockSmbSummaryCountsWidgetData.fileSharesCount
      : state.dashboardSummaryCounts.fileSharesCount?.[widgetIndex],
    policiesCount: ownProps?.useMockData
      ? mockSmbSummaryCountsWidgetData.policiesCount
      : state.dashboardSummaryCounts.policiesCount?.[widgetIndex]
  }
}

const mapDispatchToProps: DispatchProps = {
  fetchFileSharesCount
}

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  mapStateToProps,
  mapDispatchToProps
)(SmbSummaryCountsWidget)
